import type { ReactNode } from "react";
import Loader from "carbon-react/esm/components/loader/__next__";
import Message from "carbon-react/esm/components/message";

interface MessageStateProps {
  children: ReactNode;
  title: string;
  variant?: "error" | "info" | "warning";
}

function MessageState({ children, title, variant = "info" }: MessageStateProps) {
  return (
    <main className="page-content" id="main-content">
      <section aria-label={title} className="application-state">
        <Message open title={title} variant={variant}>{children}</Message>
      </section>
    </main>
  );
}

export function LoadingState() {
  return (
    <main className="centered-state" id="main-content">
      <Loader loaderLabel="Loading Loan Management" size="medium" />
    </main>
  );
}

export function StandaloneState() {
  return (
    <MessageState title="Open from Sage Intacct">
      Loan Management requires an active embedded Sage Intacct session.
    </MessageState>
  );
}

export function ErrorState({ correlationId }: { correlationId?: string }) {
  return (
    <MessageState title="Loan Management could not be loaded" variant="error">
      Reopen the application from Sage Intacct.{correlationId ? ` Reference: ${correlationId}` : ""}
    </MessageState>
  );
}

export function AccessDeniedState({ correlationId }: { correlationId: string }) {
  return (
    <MessageState title="Access denied" variant="warning">
      Your active membership does not allow access to this organization or Sage location. Reference: {correlationId}
    </MessageState>
  );
}

export function SessionExpiredState() {
  return (
    <MessageState title="Sage session expired" variant="warning">
      Refresh or reopen Loan Management from Sage Intacct.
    </MessageState>
  );
}